const ANALYTICS_DEBUG_KEY = 'SCOOPR_ANALYTICS_DEBUG_ENABLED';

let cached = false;

export const isAnalyticsDebugEnabled = () => cached;

if (typeof window !== 'undefined') {
  cached = localStorage.getItem(ANALYTICS_DEBUG_KEY) === 'true';

  const toggleAnalyticsDebug = () => {
    cached = !cached;
    localStorage.setItem(ANALYTICS_DEBUG_KEY, String(cached));
    console.log(`Analytics debugging is now ${cached ? 'enabled' : 'disabled'}`);
  };

  (window as any).__sc ??= {};
  (window as any).__sc.toggleAnalyticsDebug = toggleAnalyticsDebug;
}
